export class ShowHideLogsMessages {
    public static NoHiddenCVs:string= "You have no Hidden CVs.";
    public static NoHiddenJobs:string = "You have no Hidden Jobs.";
    public static onJobHide:string="Job hide successfully.";
    public static onCVHide:string="CV hidden  successfully.";
    public static onJobUnHide:string="Job unhide successfully.";
    public static onCVUnHide:string="CV unhidden successfully.";
    
}
